import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';

import LoginNav from '../components/LoginNav/LoginNav';
import MobileHeader from '../components/MobileHeader/MobileHeader';

import TouchButton from '../components/TouchButton';
import TouchLink from '../components/TouchLink';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import Modal from 'react-bootstrap/lib/Modal';
import Input from 'react-bootstrap/lib/Input';

import FormSection from '../components/FormSection/FormSection';
import FormGroup from '../components/FormGroup/FormGroup';

const Login = React.createClass({

    mixins: [
        LinkedStateMixin,
        ReactFireMixin
    ],

    contextTypes: {
        history: React.PropTypes.object.isRequired,
        userRef: React.PropTypes.object
    },

    getInitialState() {
        return {
            error: false,
            password: null,
            email: '',
            showForgottenPasswordModal: false
        };
    },

    login(event) {
        event.preventDefault();
        const email = this.state.email;
        const password = this.state.password;

        firebaseRoot.authWithPassword({email, password}, (error, authData) => {
            if (error) {
                console.log(error);
                // TODO(tirsen): Handle all the different error states.
                return this.setState({error: true});
            }

            if (authData) {
                if (this.context.userRef == null || !this.context.userRef.exists()) {
                    firebaseRoot.child("users").child(authData.uid).set({
                        provider: authData.provider,
                        email: email
                    }, (error) => {
                        if (error) {
                            console.log(error);
                        }
                    });
                }

                // redirect client
                const { location } = this.props;
                if (location.state && location.state.nextPathname) {
                    window.location.href = location.state.nextPathname;
                } else {
                    window.location.href = "/";
                }
            }
        });
    },

    forgottenPwrd() {
        this.setState({
            showForgottenPasswordModal: true
        });
    },

    render() {

        if (this.context.userRef && this.context.userRef.exists()) {
            return (
                <div>
                    <br/><p>Du är redan inloggad</p>

                    Återgå till <TouchLink to="/">startsidan</TouchLink><br/>

                    Eller <TouchLink to="/logout">logga ut</TouchLink>.

                </div>
            );
        }

        let hideForgottenPasswordModal = () => this.setState({showForgottenPasswordModal: false});
        const message = this.props.location && this.props.location.state ? this.props.location.state.message : null;
        return (
            <div className="screen-wrap">
                <MobileHeader
                    lessonId={this.props.params.lessonId}
                    problemId={this.props.params.problemId}
                    bookId={this.props.params.bookId}
                    type='login'
                    // Don't show the back button on the root screen.
                    backButton={this.props.location.pathname.length > 1}
                />
                <div className="screen-content">
                    <form className="section-wrap" onSubmit={this.login}>
                        <div className="section-body">
                            <div className="albert-logo"></div>
                            <div className="section-form">
                                {this.state.error && (
                                    <p className="text-danger">Bad login information</p>
                                )}
                                {message && (
                                    <p className="text-danger">{message}</p>
                                )}

                                <FormSection>
                                    <FormGroup
                                        label="Username"
                                    >
                                        <Input type="email" valueLink={this.linkState('email')} required/>
                                    </FormGroup>
                                    <FormGroup
                                        label="Password"
                                    >
                                        <Input type="password" valueLink={this.linkState('password')} required/>
                                    </FormGroup>
                                </FormSection>
                                <a onClick={this.forgottenPwrd}>Forgott password</a>
                                <ForgottenPasswordModal
                                    show={this.state.showForgottenPasswordModal}
                                    onHide={hideForgottenPasswordModal}
                                />
                            </div>
                        </div>
                        <div className="section-footer">
                            <TouchButton type="submit" bsStyle="primary" bsSize="large" block>Go</TouchButton>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
});

const ForgottenPasswordModal = React.createClass({
    render() {

        return (
            <Modal
                {...this.props}
                bsSize="large"
            >
                <Modal.Body>
                    <h3>Forgott your password?</h3>
                    <p>Enter your email address below and we'll send you instructions on how to change your password</p>
                    <FormSection>
                        <FormGroup
                            label="Email"
                            labelId="recoverEmail"
                        >
                            <Input id="recoverEmail" type="email"/>
                        </FormGroup>
                    </FormSection>
                </Modal.Body>
                <Modal.Footer>
                    <TouchButton bsStyle="link" onClick={this.props.onHide}>Cancel</TouchButton>
                    <TouchButton bsStyle="primary" onClick={this.props.onHide}>Send</TouchButton>
                </Modal.Footer>
            </Modal>
        );
    }
});

export default Login;


/** WEBPACK FOOTER **
 ** ./src/screens/Login.js
 **/